import React, { SyntheticEvent, useCallback } from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { Theme } from "@material-ui/core";
import { Icon } from "../../icon/Icon";
import styled from "styled-components";
import { Select, MenuItem } from "@material-ui/core";

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZE_OPTIONS = [5, 10, 25, 50, 100];

export type PaginationProps = {
  isLastPage?: boolean;
  onChangePage: (e: SyntheticEvent<any>, page: number) => void;
  onChangeRowsPerPage: (e: SyntheticEvent<any>) => void;
  page: number;
  count: number;
  rowsPerPage: number;
  rowsPerPageOptions: number[];
  classes: any;
  localization: any;
  theme: Theme;
  showFirstLastPageButtons: boolean;
};

const DefaultLocalization = {
  firstTooltip: "First Page",
  previousTooltip: "Previous Page",
  nextTooltip: "Next Page",
  lastTooltip: "Last Page",
  labelRowsPerPage: "Rows per page:",
};

const PaginationWrapper = styled.td`
  padding: 0 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const SimpleTablePagination = (p: PaginationProps) => {
  const {
    isLastPage,
    count,
    page,
    showFirstLastPageButtons,
    onChangePage,
    rowsPerPage,
    rowsPerPageOptions,
    onChangeRowsPerPage,
  } = p;
  const localization = { ...DefaultLocalization, ...p.localization };
  const handleFirstPageButtonClick = useCallback(
    (event: SyntheticEvent<any>) => {
      onChangePage(event, 0);
    },
    [onChangePage]
  );
  const handleBackButtonClick = useCallback(
    (event: SyntheticEvent<any>) => {
      onChangePage(event, p.page - 1);
    },
    [onChangePage, p.page]
  );
  const handleNextButtonClick = useCallback(
    (event: SyntheticEvent<any>) => {
      onChangePage(event, p.page + 1);
    },
    [onChangePage, p.page]
  );

  return (
    <>
      <PaginationWrapper>
        <div>
          {showFirstLastPageButtons && (
            <Tooltip title={localization.firstTooltip}>
              <span>
                <IconButton
                  onClick={handleFirstPageButtonClick}
                  disabled={page === 0}
                  aria-label={localization.firstAriaLabel}
                >
                  <Icon icon="faAngleDoubleLeft" />
                </IconButton>
              </span>
            </Tooltip>
          )}
          <span>
            Rows per page:
          </span>
          <span>
            <Select
              labelId="items-per-page-select-label"
              id="items-per-page-select"
              value={rowsPerPage}
              onChange={onChangeRowsPerPage}
            >
              {rowsPerPageOptions?.map(item => {
                return <MenuItem key={item} value={item}>{item}</MenuItem>
              })}
            </Select>
          </span>
          <Tooltip title={localization.previousTooltip}>
            <span>
              <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label={localization.previousAriaLabel}
              >
                <Icon icon="faAngleLeft" />
              </IconButton>
            </span>
          </Tooltip>
          <Typography
            variant="caption"
            style={{
              flex: 1,
              textAlign: "center",
              alignSelf: "center",
              flexBasis: "inherit",
            }}
          >
            {page}
          </Typography>
          <Tooltip title={localization.nextTooltip}>
            <span>
              <IconButton
                onClick={handleNextButtonClick}
                disabled={isLastPage || count === 0}
                aria-label={localization.nextAriaLabel}
              >
                <Icon icon="faAngleRight" />
              </IconButton>
            </span>
          </Tooltip>
        </div>
      </PaginationWrapper>
    </>
  );
};
